import { keyType } from '../constants/string'

import { getFocusables } from './getFocusables'

export const focusTrapCreator = (event, currentContainer: HTMLElement, openWidget: boolean) => {
  const currentKey = event.key.toLowerCase()

  if (currentKey === keyType.TAB && openWidget) {
    event.stopPropagation()
    const currentTarget = event.target
    const focusData = getFocusables(currentContainer, currentTarget)
    const lastFocusableElementIndex = focusData.focusables.length - 1

    if (event.shiftKey) {
      if (!focusData.focusIndex) {
        event.preventDefault()
        focusData.focusables[lastFocusableElementIndex].focus()
      }
    } else {
      if (focusData.focusIndex === lastFocusableElementIndex) {
        event.preventDefault()
        focusData.focusables[0].focus()
      }
    }
  }
}
